(() => {
  /* Form spam guard: blocks submissions that fill the hidden honeypot field or arrive faster than a person can type. */
  const bbbioMinimumFillMs = 3000;
  const bbbioLoadedAt = Date.now();

  document.addEventListener(
    'submit',
    (bbbioEvent) => {
      const bbbioForm = bbbioEvent.target;
      if (!(bbbioForm instanceof HTMLFormElement)) return;
      const bbbioTrap = bbbioForm.querySelector('[data-bbbio-honeypot]');
      if (!bbbioTrap) return;

      const bbbioTrapFilled = bbbioTrap.value.trim() !== '';
      const bbbioTooFast = Date.now() - bbbioLoadedAt < bbbioMinimumFillMs;
      if (!bbbioTrapFilled && !bbbioTooFast) return;

      bbbioEvent.preventDefault();
      bbbioEvent.stopImmediatePropagation();

      if (bbbioTrapFilled) return;
      const bbbioStatus = bbbioForm.querySelector('[data-bbbio-spam-guard-status]');
      if (bbbioStatus) {
        bbbioStatus.hidden = false;
        bbbioStatus.textContent = bbbioStatus.dataset.bbbioMessage || 'Please wait a moment, then submit again.';
      }
    },
    true
  );

  /* Email protection: addresses are rendered base64-encoded and only restored in the browser. */
  const bbbioDecode = (bbbioValue) => {
    try {
      return decodeURIComponent(
        Array.from(window.atob(bbbioValue), (bbbioChar) => '%' + bbbioChar.charCodeAt(0).toString(16).padStart(2, '0')).join('')
      );
    } catch (bbbioError) {
      return '';
    }
  };

  const bbbioRestoreEmails = (bbbioScope) => {
    bbbioScope.querySelectorAll('[data-bbbio-mailto]').forEach((bbbioLink) => {
      const bbbioTarget = bbbioDecode(bbbioLink.dataset.bbbioMailto);
      if (!bbbioTarget) return;
      bbbioLink.setAttribute('href', 'mailto:' + bbbioTarget);
      bbbioLink.removeAttribute('data-bbbio-mailto');
    });
    bbbioScope.querySelectorAll('[data-bbbio-email-text]').forEach((bbbioText) => {
      const bbbioAddress = bbbioDecode(bbbioText.dataset.bbbioEmailText);
      if (!bbbioAddress) return;
      bbbioText.textContent = bbbioAddress;
      bbbioText.removeAttribute('data-bbbio-email-text');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bbbioRestoreEmails(document));
  } else {
    bbbioRestoreEmails(document);
  }
  document.addEventListener('shopify:section:load', (bbbioEvent) => bbbioRestoreEmails(bbbioEvent.target));
})();
